export type Feature =
  | 'DefaultDimensionsRule'
  | 'DefaultWeightRule'
  | 'DefaultExtrasRule'
  | 'InlineRules'
  | 'Windsor'
  | 'SetupProgress'
  | 'Dash:OrderProcess'
  | 'Dash:CSV'
  | 'Dash:Sold'
  | 'Dash:Booked'
  | 'Dash:InTransit'
  | 'Dash:AwaitingDispatch'
  | 'Dash:Help'
  | 'Dash:PriceMatrix'
  | 'Dash:Link:RuleManager'
  | 'Dash:Link:SelfServe'
  | 'QuickLink:Help'
  | 'QuickLink:Downloads'
  | 'BusinessQuotes'
  | 'SetupPrompt'
  | 'Products'
  | 'Rewards'
  | 'AutoAddDdpWhenDduUnavailable'
  | 'Referrals'
  | 'ReferralShareEmail'
  | 'ReferralShareWhatsApp'
  | 'ReferralShareFacebook'
  | 'ReferralShareX'
  | 'ReferralShareLinkedIn'
  | 'ReferralShareReddit'
  | 'SaveAddressOnSenderUpdate'
  | 'UpdateCustomerOnSenderUpdate'
  | 'SurchargePayments'
  | 'KnowYourCustomer'
  | 'ShowQuoteProtectionUnavailableMessage'
  | 'MarketplaceQuickSelect'
  | 'CsvMapping'
  | 'AdditionalHandling'
  | 'CsvUpload'
  | 'CsvUploadExamples'
  | 'PrePay'
  | 'DropDownPanelNavigation'
  | 'RestoreItem'
  | 'PreBookingVerification'
  | 'Surcharges'
  | 'CollectionDates'
  | 'RefreshCollectionDates'
  | 'ForceEarliestCollectionDate'
  | 'HideDimensionsIfNotRequired'
  | 'DeliveryInstructions'
  | 'DeliverySafePlace'
  | 'DeliveryBuyerNote'
  | 'eBayDispatchIssuesBanner'
  | 'eBayImportIssuesBanner'
  | 'Support'
  | 'Claims'
  | 'Banners'
  | 'VipSupport'
  | 'BannerBackToOldTool'
  | 'ProductFruits'
  | 'ProductFruitsFirstOrderOnly'
  | 'PickingList'
  | 'AutoMarkAsDispatchedBookingPrompt'
  | 'Prices'
  | 'Rates'
  | 'RatesSidepanel'
  | 'RuleManager'
  | 'PackageContents'
  | 'GroupExtras'
  | 'Graphs'
  | 'Illustrations'
  | 'Tracking'
  | 'PackageImages'
  | 'Search'
  | 'ReturnCollection'
  | 'ShopProximityMessage'
  | 'AdditionalDutiesWarning'
  | 'ServiceLogos'
  | 'Labels'
  | 'VersionRevert'
  | 'VersionFeedback'
  | 'PaymentAnalytics'
  | 'PaymentAnalyticsGA4'
  | 'LiveChat'
  | 'Manifests'
  | 'Protection'
  | 'ParcelSplitting'
  | 'ForceSingleParcelConsignments'
  | 'Consignments'
  | 'Extras'
  | 'Extra:ExtendedBaseCover'
  | 'Extra:Cover'
  | 'Extra:Sms'
  | 'Extra:DeliveryGuarantee'
  | 'Extra:PrintInStore'
  | 'Extra:Signature'
  | 'CustomiseServices'
  | 'Graphs:Spend'
  | 'Graphs:SpendVsBusiness'
  | 'Discounts'
  | 'Graphs:Volume'
  | 'Graphs:VolumeVsBusiness'
  | 'Link:SoldItems'
  | 'Link:BookedItems'
  | 'Link:InTransit'
  | 'Link:AwaitingDispatch'
  | 'Link:Statements'
  | 'Link:AccountConcerns'
  | 'Dash:AccountConcerns'
  | 'SenderPersonalOption'
  | 'Dash:Integration:Shopify'
  | 'Dash:Integration:eBay'
  | 'AddItemMenu'
  // Analytics Dashboards
  | 'Dashboard:Performance'
  | 'Dashboard:Insights'
  | 'Dashboard:Costs'
  | 'Dashboard:AdvancedOverview'
  | 'Dashboard:Orders'
  | 'ArchivedOrders';

// Mapped the none-colon feature names to their colon counterparts
export const SanitisedFeatureMapping: { [key: string]: Feature } = {
  GraphsVolume: 'Graphs:Volume',
  GraphsVolumeVsBusiness: 'Graphs:VolumeVsBusiness',
  GraphsSpend: 'Graphs:Spend',
  GraphsSpendVsBusiness: 'Graphs:SpendVsBusiness',
  DashboardPerformance: 'Dashboard:Performance',
  DashboardInsights: 'Dashboard:Insights',
  DashboardCosts: 'Dashboard:Costs',
  DashboardOrders: 'Dashboard:Orders',
  DashboardAdvancedOverview: 'Dashboard:AdvancedOverview'
};
